"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Use "ua-parser-js" over "detect-browser" to get more detailed information.

var ua_parser_js_1 = require("ua-parser-js");

var Versioning_1 = require("../versioning/Versioning");
/**
 * [[DefaultUserAgentParser]] uses UAParser to parse the browser's user agent.
 * It is responsible to hold and provide browser, OS and device specific information.
 */


var DefaultUserAgentParser = /*#__PURE__*/function () {
  function DefaultUserAgentParser(logger) {
    _classCallCheck(this, DefaultUserAgentParser);

    var _a, _b, _c, _d, _e, _f, _g;

    try {
      this.parserResult = navigator && navigator.userAgent ? new ua_parser_js_1.UAParser(navigator.userAgent).getResult() : undefined;
    } catch (error) {
      /* istanbul ignore next */
      logger.error(error.message);
    }

    this.browserMajorVersion = ((_c = (_b = (_a = this.parserResult) === null || _a === void 0 ? void 0 : _a.browser) === null || _b === void 0 ? void 0 : _b.version) === null || _c === void 0 ? void 0 : _c.split('.')[0]) || DefaultUserAgentParser.UNAVAILABLE;
    this.browserName = ((_d = this.parserResult) === null || _d === void 0 ? void 0 : _d.browser.name) || DefaultUserAgentParser.UNAVAILABLE;
    this.browserVersion = ((_e = this.parserResult) === null || _e === void 0 ? void 0 : _e.browser.version) || DefaultUserAgentParser.UNAVAILABLE;
    this.deviceName = [((_f = this.parserResult) === null || _f === void 0 ? void 0 : _f.device.vendor) || '', ((_g = this.parserResult) === null || _g === void 0 ? void 0 : _g.device.model) || ''].join(' ').trim() || DefaultUserAgentParser.UNAVAILABLE;
  }

  _createClass(DefaultUserAgentParser, [{
    key: "getParserResult",
    value: function getParserResult() {
      var _a, _b;

      return {
        browserMajorVersion: this.browserMajorVersion,
        browserName: this.browserName,
        browserVersion: this.browserVersion,
        deviceName: this.deviceName,
        osName: ((_a = this.parserResult) === null || _a === void 0 ? void 0 : _a.os.name) || DefaultUserAgentParser.UNAVAILABLE,
        osVersion: ((_b = this.parserResult) === null || _b === void 0 ? void 0 : _b.os.version) || DefaultUserAgentParser.UNAVAILABLE,
        sdkVersion: Versioning_1.default.sdkVersion,
        sdkName: Versioning_1.default.sdkName
      };
    }
  }]);

  return DefaultUserAgentParser;
}();

exports.default = DefaultUserAgentParser;
DefaultUserAgentParser.UNAVAILABLE = 'Unavailable';